import { IconButton, InputAdornment } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import React from 'react';
import { getMobileOperatingSystem } from 'src/utils/getUtils';
import InputText from '../InputText';

function InputPlusAndMinusNumber({
  value,
  onChange,
  onMinus,
  onPlus,
  onBlur,
  style = {},
  onKeyDown,
  onKeyUp,
  fontSize = 30,
  placeHolder = '',
  label = '',
}) {
  return (
    <InputText
      autoFocus
      value={value}
      label={label}
      onChange={onChange}
      placeholder={placeHolder}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      inputMode={getMobileOperatingSystem() === 'iOS' ? 'text' : 'numeric'}
      onBlur={onBlur}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <IconButton
              aria-label='Remove um item'
              onClick={onMinus}>
              <Remove />
            </IconButton>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label='Adiciona um item'
              onClick={onPlus}>
              <Add />
            </IconButton>
          </InputAdornment>
        ),
      }}
      inputProps={{
        style: {
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: fontSize,
        },
      }}
    />
  );
}

export default InputPlusAndMinusNumber;
